import { createContext } from 'react';
import { AppConfig, UserSession } from '@stacks/connect';

export type UserData = {
  testnet: string;
  mainnet: string;
} | null;

const defaultState = (): UserData => {
  const appConfig = new AppConfig(['store_write'], document.location.href);
  const userSession = new UserSession({ appConfig });

  if (userSession.isUserSignedIn()) {
    return userSession.loadUserData().profile.stxAddress;
  }

  return null;
};

export const AuthAddressContext = createContext<UserData | null>(defaultState());
